import { Grid } from "@material-ui/core";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import { connect } from "react-redux";
import { getBookingOverview, getProjects, getStatusByYear } from "../../actions/GenomicsResearchAction";
import React, { useEffect, useState } from 'react';
import { useUser } from "../../../providers/user"
import SunilKumar from './sunilkumar.jpeg'
import logo from './bayer.png'
import { useHistory } from 'react-router-dom';
const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        card: {
            height: "100%",
            padding: "20px",
        },
        cardContent: {
            textAlign: "center",
        },
        center: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
        },
        text: { color: "black" },
    })
);


interface Props {
    getBookingOverview: any;
    bookingoverview: any;
    userDetails: any;
    getProjects: any;
    projects: any;
    getStatusByYear: any;
    fetchStatusByYear: any;
    loading: any
}

const Dashboard: React.FC<Props> = ({
    getBookingOverview,
    bookingoverview,
    getProjects,
    getStatusByYear,
    fetchStatusByYear,
    projects,
    loading,
}) => {
    const classes = useStyles();
    const [showWelcomePage, setShowWelcomePage] = useState(true);
    const user = useUser();
    const history = useHistory();

    // useEffect(() => {
    //     const redirectTimeout = setTimeout(() => {
    //       history.push('/dashboard/gnre/samples_tracker_count');
    //     }, 10000); // 10 seconds in milliseconds

    //     return () => clearTimeout(redirectTimeout);
    //   }, [history]);

    return (
        <div style={{ width: "100%", margin: "60px auto" }}>
            <div style={{ border: "2px solid #0b2857", borderRadius: "10px" }}>
                <div style={{ padding: "10px", color: "black" }}>
                    <Grid container>
                        <Grid item xs={12} md={4}>
                            <img src={logo} alt="Sunil Kumar" style={{ width: '30%' }} />
                        </Grid>
                        <Grid item xs={12} md={5}>
                            <h2 style={{ textAlign: "center" }}>Welcome {user?.profile?.scientist?.salutation} {user?.profile?.scientist?.name}</h2>
                            <h4 style={{ textAlign: "center" }}>{user?.profile?.scientist?.headline}</h4>
                        </Grid>
                        <Grid item xs={7} style={{ marginTop: "10px" }}>
                            <div>
                                <h2>About {user?.profile?.scientist?.salutation} {user?.profile?.scientist?.name}</h2>
                                <p style={{ fontSize: "18px" }}>
                                    {user?.profile?.scientist?.about}
                                </p>
                                <h4 style={{ marginTop: "20px" }}>Education and Credentials:</h4>
                                <p style={{ fontSize: "18px" }}>
                                    <ul>
                                        <li>
                                            {/* {user?.profile?.scientist?.education} */}
                                            Education
                                            Eidgenössische Technische Hochschule Zürich Graphic
                                            Eidgenössische Technische Hochschule Zürich
                                            Doctor of Philosophy (Ph.D.)Plant Sciences
                                            2004 - 2008
                                        </li>
                                        <li>
                                            University of Agricultural Sciences, Dharwad Graphic
                                            University of Agricultural Sciences, Dharwad
                                            Master of Science (M.Sc.)Agricultural genetics and breeding
                                            1998 - 2000
                                        </li>
                                        <li>
                                            University of Agricultural Sciences, Dharwad Graphic
                                            University of Agricultural Sciences, Dharwad
                                            Bachelor of Science (B.S.)Agriculture, General
                                            1994 - 1998
                                        </li>
                                    </ul>
                                </p>
                            </div>
                        </Grid>
                        <Grid item xs={1}>

                        </Grid>
                        <Grid item xs={4}>
                            <img src={user?.profile?.scientist?.profile_pic} alt="Sunil Kumar" style={{ width: '80%' }} />
                        </Grid>
                    </Grid>
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = (state: any) => ({
    bookingoverview: state.GenomicsCAReducer.bookingoverview,
    projects: state.GenomicsCAReducer.projects,
    fetchStatusByYear: state.GenomicsCAReducer.fetchStatusByYear,
    loading: state.GenomicsCAReducer.loading,
});

export default connect(mapStateToProps, {
    getBookingOverview,
    getProjects,
    getStatusByYear,
})(Dashboard);
